import * as React from 'react'
import Helmet from 'react-helmet'
import { useTheme } from '@emotion/react'

import * as Styled from './Breadcrumbs.styles'
import * as StyledContainer from './BreadcrumbsContainer.styles'
import { checkDictionary } from './utils'
import { BREADCRUMB } from '../../utils/dataTrackingValues'

const Breadcrumbs = ({
  crumbs = [],
  path = '',
  siteURL = '',
  CustomLink = null,
  removeTrailingSlashes = false,
  ...props
}) => {
  const { components } = useTheme()

  let crumbList = crumbs || []
  // Creates crumbs based off the page path if none have been provided
  if (crumbList.length <= 0 && path !== '/') {
    crumbList = path.split('/').map((node, index) => {
      let currentPath =
        index === 0 ? '/' : `${path.substring(0, path.indexOf(node))}${node}`
      const shortName =
        index === 0 ? 'Home' : checkDictionary(node.replace(/-/g, ' '))
      if (!removeTrailingSlashes && index !== 0) {
        currentPath += '/'
      }
      return { shortName, path: currentPath }
    })
  }

  return (
    crumbList.length > 0 && (
      <StyledContainer.Section
        backgroundColor={components?.Breadcrumbs?.backgroundColor}
      >
        <Styled.BreadcrumbContainer className="leshen-breadcrumbs" {...props}>
          <Helmet>
            <script type="application/ld+json">
              {`
          {
            "@context":"https://schema.org",
            "@type": "BreadcrumbList",
              "itemListElement": [
              ${crumbList.map(
                (crumb, i) =>
                  `
                    {
                      "@type": "ListItem",
                      "position": "${i + 1}",
                      "item": {
                        "@id": "${siteURL}${crumbList[i].path}",
                        "name": "${crumb.shortName}"
                      }
                    }
                  `
              )}
            ]
          }
        `}
            </script>
          </Helmet>
          {crumbList.map(({ shortName, path: crumbPath }, index) =>
            index === crumbList.length - 1 ? (
              <Styled.LastBreadcrumb
                className="leshen-breadcrumb-last"
                key={shortName}
              >
                {shortName}
              </Styled.LastBreadcrumb>
            ) : (
              <Styled.Breadcrumb
                className="leshen-breadcrumb"
                key={shortName}
                CustomLink={CustomLink}
                to={crumbPath}
                data-tracking={BREADCRUMB.LINK}
              >
                {shortName}
              </Styled.Breadcrumb>
            )
          )}
        </Styled.BreadcrumbContainer>
      </StyledContainer.Section>
    )
  )
}

export default Breadcrumbs
